import { Box, TextField, Typography } from '@mui/material';

interface TitleSectionProps {
    isEditing: boolean;
    editedText: string;
    setEditedText: (value: string) => void;
    text: string;
}

export const TitleSection = ({ isEditing, editedText, setEditedText, text }: TitleSectionProps) => (
    <Box sx={{ mb: 3 }}>
        <Typography color="text.secondary" variant="subtitle2" gutterBottom>
            Title
        </Typography>
        {isEditing ? (
            <TextField
                fullWidth
                multiline
                value={editedText}
                onChange={(e) => setEditedText(e.target.value)}
                size="small"
                sx={{
                    '& .MuiOutlinedInput-root': {
                        bgcolor: 'background.paper'
                    }
                }}
            />
        ) : (
            <Typography variant="h6">{text}</Typography>
        )}
    </Box>
); 